import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './WaitingApprovals.css';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getStates, getClients, getProject, fetchMonths, getFinalAttendanceReport } from '../../../services/monthlyAttendanceService';
import { getGenders, getQualifications, getDesignations, createEmployee, updateEmployee, getUsers } from "../../../services/employeeCreationService";
import { capitalizeFirstLetter } from '../../../utils/validations';
import { Link } from 'react-router-dom';
import { fetchWaitingApprovals, fetchEmployeeFromSelf, getTransferDetails, updateApprovalStatus } from '../../../services/resgisterEmployeesList';
import { resendPersonalInfoLink } from "../../../services/draftApplicationService";
const WaitingApprovals = () => {
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(0);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(null);
    const effectRan = useRef(false);
    const [employeeData, setEmployeeData] = useState([]); // ✅ new state for table data
    const [designations, setDesignations] = useState([]);
    const [designation, setDesignation] = useState(null);
    const [selectedTransfer, setSelectedTransfer] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [isFocused, setIsFocused] = useState({
        state: false,
        // district: false,
        month: false,
        year: false,
        project: false,
        clients: false,
        designation: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && month && year && project;
    // Get user info from localStorage (or API)

    const roleId = localStorage.getItem('roleId');
    const employeeId = localStorage.getItem('employeeId');


    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);



    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);

                    const filterData = [
                        { value: 0, label: "All Districts" },
                        ...data
                            //.filter(item => item.districtId === 39)
                            .map(item => ({
                                value: item.districtId,
                                label: item.districtName
                            }))
                    ];

                    setDistrictOptions(filterData);
                    // ✅ Set district to the default 'All Districts' option when state loads
                    // setDistrict(0);

                } catch (err) {
                    console.error('Error fetching districts:', err);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null); // Clear district if state is cleared
        }
    }, [state]);
    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                    const data = await getClients(state);
                    setClientResponse(data.map(client => ({
                        value: client.id,
                        label: client.clientName,
                    }))
                    );
                } catch (error) {
                    console.error('Error fetching states:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
                }
            };
            fetchClients();
        }
        else {
            setClients(null);
        }
    }, [state]);


    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);


    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        let value = selectedOption ? selectedOption.value : null;
        // Special handling for "All Districts"
        // Special handling for "All Districts"
        if (field === "district" && value === 0) {
            value = 0; // 0 = All districts (numeric, compatible with ID-based logic)
        }
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'clients':
                setClients(value);
                setProject(null);
                break;
            case 'district':
                setDistrict(value);
                // setMonth(null);
                break;
            case 'designation':
                setDesignation(value);
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };
    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };
    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);

    useEffect(() => {
        const fetchEmployeeData = async () => {
            const roleId = localStorage.getItem("roleId");
            const employeeId = localStorage.getItem("employeeId");

            // ---- ADMIN (roleId === "1") ----
            if (roleId === "1" || roleId === "15") {
                if (!state) {
                    setEmployeeData([]);
                    return;
                }

                try {
                    const data = await fetchWaitingApprovals(state, district, designation);
                    setEmployeeData(Array.isArray(data) ? data : []);
                } catch (error) {
                    console.error("Admin fetch error:", error);
                    setErrors((prev) => ({ ...prev, general: "Failed to fetch employeeData" }));
                    setEmployeeData([]);
                }
            }

            // ---- EMPLOYEE (roleId === "13") ----
            else if (roleId === "13") {
                if (!employeeId) {
                    setEmployeeData([]);
                    return;
                }

                try {
                    const data = await fetchEmployeeFromSelf(employeeId);
                    // API may return a single object → wrap in array for the table
                    setEmployeeData(Array.isArray(data) ? data : [data]);
                } catch (error) {
                    console.error("Employee fetch error:", error);
                    setErrors((prev) => ({ ...prev, general: "Failed to fetch employee" }));
                    setEmployeeData([]);
                }
            }
        };

        fetchEmployeeData();
    }, [state, district, designation]);



    //   // ✅ Send Email Function
    // const handleSendEmail = async (employeeUniqueId) => {
    //   const payload = {
    //     name: localStorage.getItem("full_name"),
    //     role: localStorage.getItem("role"),
    //     employeeId: localStorage.getItem("employeeId"),
    //   };

    //   try {
    //     const response = await fetch(
    //       `${process.env.REACT_APP_API_BASE_URL}/api/personal-info/${employeeUniqueId}/send-email`,
    //       {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(payload),
    //       }
    //     );

    //     if (!response.ok) throw new Error('Failed to send email');

    //     // ✅ Update status locally
    //     const updatedEmployees = employeeData.map((emp) =>
    //       emp.employeeUniqueId === employeeUniqueId
    //         ? { ...emp, emailSent: true, resignationStatus: "DONE" }
    //         : emp
    //     );

    //     setEmployeeData(updatedEmployees);
    //     alert('Email sent successfully!');
    //   } catch (err) {
    //     console.error(err);
    //     alert('Failed to send email. Please try again.');
    //   }
    // };

    // const handleSendEmail = async (employeeUniqueId) => {
    //     const payload = {
    //         name: localStorage.getItem("full_name"),
    //         role: localStorage.getItem("role"),
    //         employeeId: localStorage.getItem("employeeId"),
    //     };

    //     try {
    //         // Using Axios service
    //         const data = await resendPersonalInfoLink(employeeUniqueId, payload);

    //         const updatedEmployees = employeeData.map((emp) =>
    //             emp.employeeUniqueId === employeeUniqueId
    //                 ? { ...emp, emailSent: true, resignationStatus: "DONE" }
    //                 : emp
    //         );

    //         setEmployeeData(updatedEmployees);
    //         alert("Email sent successfully!");
    //         return data;
    //     } catch (err) {
    //         console.error(err);
    //         alert("Failed to send email. Please try again.");
    //         throw err;
    //     }
    // };


    // Fetch designations
    useEffect(() => {
        const fetchDesignation = async () => {
            try {
                const data = await getDesignations();
                if (Array.isArray(data)) {
                    setDesignations(
                        data.map((d) => ({
                            value: d.id,
                            label: d.designationName,
                        }))
                    );
                } else {
                    console.error("Invalid response: designations should be an array");
                }
            } catch (err) {
                console.error("Error fetching designation:", err);
            }
        };
        if (effectRan.current === false) {
            fetchDesignation();
        }
        return () => {
            effectRan.current = true;
        }

    }, []);

    const handleView = async (id) => {
        try {
            const data = await getTransferDetails(id);

            console.log(data);

            setSelectedTransfer(data);
            setShowModal(true);

        } catch (err) {
            console.error(err);
            alert("Failed to fetch transfer details");
        }
    };

    const handleStatusChange = async (status) => {
        try {

            await updateApprovalStatus(selectedTransfer.transferId, status);

            alert(`Transfer ${status} successfully`);

            setShowModal(false);

            // Refresh table
            if (roleId === "1" || roleId === "15") {
                const data = await fetchWaitingApprovals(state, district, designation);
                setEmployeeData(data);
            }

        } catch (error) {
            console.error(error);
            alert("Failed to update transfer status");
        }
    };
    return (

        <div className="registed-employee-container">
            {/* {roleId === "1" && ( */}
            <div className="registed-employee-box">
                <h2 className="registed-employee-heading">Employees Transfers Approvals</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                {roleId === "1" || roleId === "15" && (
                    <form>
                        <div className="registed-employee-maincontainer">
                            <div className="registed-employee-container-part">
                                <div className={`registed-employee-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                    <Select
                                        name="state"
                                        options={stateOptions}
                                        value={stateOptions.find(opt => opt.value === state) || null}
                                        onChange={option => handleInputChange(option, 'state')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}

                                    />
                                    <label><span className="required">*</span>State</label>
                                    {errors.state && <div className="error-message">{errors.state}</div>}
                                </div>
                            </div>
                            <div className="registed-employee-container-part">
                                <div className="registed-employee-container-part">
                                    <div className={`registed-employee-floating-label-container ${isFocused.district || district !== null ? 'float-label' : ''}`}>
                                        <Select
                                            // ... (other Select props)
                                            name="district"
                                            options={districtOptions}
                                            // value comparison remains correct
                                            value={districtOptions.find(opt => opt.value === district) || null}
                                            onChange={option => handleInputChange(option, 'district')}
                                            onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                            onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                            placeholder=" "
                                            isClearable
                                            menuPortalTarget={document.body}
                                            styles={selectStyles}
                                        />
                                        <label>District</label>
                                        {errors.district && <div className="error-message">{errors.district}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="registed-employee-maincontainer">
                        <div className="registed-employee-container-part">
                            <div className={`registed-employee-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="registed-employee-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="registed-employee-container-part">
                            <div className={`registed-employee-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>*/}
                        <div className="registed-employee-maincontainer">
                            <div className="registed-employee-container-part">
                                <div className={`registed-employee-floating-label-container ${isFocused.designation || designation ? 'float-label' : ''}`}>
                                    <Select
                                        options={designations}
                                        value={designations.find((option) => option.value === designation) || null}
                                        onChange={(selectedOption) => {
                                            setDesignation(selectedOption ? selectedOption.value : null);
                                            handleInputChange(selectedOption, 'designation');
                                        }}
                                        placeholder=""
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />

                                    <label>Designation</label>

                                </div>

                            </div>
                            <div className="registed-employee-container-part">
                                {/* <div className={`registed-employee-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>
                                    <span className="required">*</span>Project
                                </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div> */}
                            </div>

                        </div>
                    </form>
                )

                }
            </div>





            <div className="resign-table">
                <div className="resign-mid-report">
                    <table className="resign-report">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Employee ID</th>
                                <th>Employee Name</th>
                                <th>Designation</th>
                                <th>Date of Request</th>
                                <th>Request Raised By</th>
                                <th>Reason for Transfer</th>
                                <th>View Document</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeData.length > 0 ? (
                                employeeData.map((emp, index) => (
                                    <tr key={emp.id}>
                                        <td>{index + 1}</td>
                                        <td>{emp.employeeId}</td>
                                        <td>{emp.employeeName || 'N/A'}</td>
                                        <td>{emp.toDesignation || 'N/A'}</td>
                                        <td>{format(emp.createdAt, "dd-MM-yyyy") || 'N/A'}</td>
                                        <td> {emp.createdBy || "-"}</td>
                                        <td> {emp.remarks || "-"}</td>
                                        <td>
                                            {emp.transferDocumentUrl ? (
                                                <a
                                                    href={emp.transferDocumentUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="doc-link"
                                                    title={emp.transferDocumentFileName || 'View document'}
                                                >
                                                    View Document
                                                </a>
                                            ) : (
                                                <span style={{ color: '#999' }}>No file</span>
                                            )}
                                        </td>
                                        <td>
                                            <button
                                                className="action-btn"
                                                onClick={() => handleView(emp.id)}
                                            >
                                                View
                                            </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: 'center' }}>
                                        No Employee found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
            {showModal && selectedTransfer && (
                <div className="approvals-overlay">
                    <div className="approvals-content">

                        <div className="approvals-header">
                            <h2>Employee Transfer Approval</h2>
                            <button
                                className="approvals-close-btn"
                                onClick={() => setShowModal(false)}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="approvals-employee-card">
                            <div>
                                <label>Employee ID</label>
                                <span>{selectedTransfer.employeeId}</span>
                            </div>

                            <div>
                                <label>Employee Name</label>
                                <span>{selectedTransfer.employeeName}</span>
                            </div>

                            <div>
                                <label>Status</label>
                                <span className="status-badge">
                                    {selectedTransfer.status}
                                </span>
                            </div>
                        </div>

                        <div className="approvals-grid">

                            {/* Present Details */}

                            <div className="approvals-card-1">

                                <h3>Present Posting Details</h3>

                                <table className="approvals-waiting">
                                    <tbody>

                                        <tr>
                                            <th>State</th>
                                            <td>{selectedTransfer.present.state || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>District</th>
                                            <td>{selectedTransfer.present.district || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>Designation</th>
                                            <td>{selectedTransfer.present.designation || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>Location</th>
                                            <td>{selectedTransfer.present.location || "-"}</td>
                                        </tr>

                                        {/* <tr>
                                            <th>Reporting To</th>
                                            <td>{selectedTransfer.present.reportingTo || "-"}</td>
                                        </tr> */}

                                    </tbody>
                                </table>

                            </div>

                            {/* Transfer Details */}

                            <div className="approvals-card">

                                <h3>Requested Transfer Details</h3>

                                <table className="approvals-waiting">
                                    <tbody>

                                        <tr>
                                            <th>State</th>
                                            <td>{selectedTransfer.transfer.state || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>District</th>
                                            <td>{selectedTransfer.transfer.district || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>Designation</th>
                                            <td>{selectedTransfer.transfer.designation || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>Location</th>
                                            <td>{selectedTransfer.transfer.location || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>Reporting To</th>
                                            <td>{selectedTransfer.transfer.reportingTo || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>Request Date</th>
                                            <td>{format(selectedTransfer.transfer.fromDate, "dd-MM-yyyy") || "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>Reason for Transfer</th>
                                            <td>{selectedTransfer.transfer.remarks || "-"}</td>
                                        </tr>

                                    </tbody>
                                </table>

                            </div>

                        </div>

                        <div className="approvals-footer">

                            <button
                                className="approvals-btn reject-btn"
                                onClick={() => handleStatusChange("REJECTED")}
                            >
                                Reject
                            </button>

                            <button
                                className="approvals-btn approve-btn"
                                onClick={() => handleStatusChange("APPROVED")}
                            >
                                Approve
                            </button>

                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default WaitingApprovals;